<template>
    <div :class="{'mainPart':memberSource==0}">
        <el-form :model="basicForm" v-model="labelPosition" :label-width="memberSource==1?'180px':'120px'" class="commonForm">
            <el-form-item v-if="memberSource==0" label="优惠券编码" class="defineRow">
                <el-input v-model.trim ="basicForm.code" maxlength="20"></el-input> 
                <el-button type="primary" class="btnRight" @click="yanzheng" :loading="loadingshows">验证</el-button>
            </el-form-item>
              <el-form-item label="优惠券面值" >
                  <el-input v-model="basicForm.facevalue" disabled ><i slot="prepend">￥</i></el-input>
              </el-form-item>
              <el-form-item label="最低消费金额">
                  <el-input v-model="basicForm.minconamount" disabled><i slot="prepend">￥</i></el-input>
              </el-form-item>
              <el-form-item label="优惠券有效期" >
                  <!-- S 双日期选择组件 -->
                  <TwoDatePicker :disabled="1" @twoDateObtain="twoDateReceive" :startvaldate="basicForm.startvaldate" :endvaldate="basicForm.endvaldate" ></TwoDatePicker>
                  <!-- E 双日期选择组件 -->
              </el-form-item>
              <el-form-item label="优惠券简述">
                  <el-input type="textarea" v-model="basicForm.sketch" disabled></el-input>
              </el-form-item>
              <el-form-item label="	订单金额" required>
                  <el-input v-model="basicForm.allamount" maxlength="9" @input="allamounts"><i slot="prepend">￥</i></el-input>
              </el-form-item>
              <el-form-item label="订单内容" required>
                  <el-input type="textarea" v-model="basicForm.ordercontent" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="订单备注">
                  <el-input type="textarea" v-model="basicForm.ordermemo" maxlength="100"></el-input>
              </el-form-item>
        </el-form>
        <div v-if="memberSource==1" class="el-dialog__footer">
          <span class="dialog-footer">
            <el-button type="primary" @click="closeCoupon(1)">确定</el-button>
            <el-button @click="closeCoupon(0)">取消</el-button>
          </span>
        </div>
        <div v-else class="bottomBtn">
            <el-button type="primary" @click="suBmission" :loading="loadingshow">提交</el-button>
        </div>

    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { Message, MessageBox } from "element-ui";
export default {
  name: "Coupon",
  // ==================================== 组件====================================
  components: {
   TwoDatePicker: resolve =>
         require(["@/components/common/TwoDatePicker.vue"], resolve), //双日期选择组件
  },
  data() {
    return {
			loadingshow:false,
			loadingshows:false,
      update:true,
      cover:'cover',// 券卡验证组件传值
      codeType:'1',//券卡类型-优惠券
      labelPosition: "right", //labe文字右对齐
      rules: {
        facevalue: [{ required: true, message: "优惠券面值不能为空！" },
                    { validator: this.facevalues, trigger: "blur" }], //券卡面值
        minconamount: [{ required: true, message: "最低消费金额不能为空！" },
                       { validator: this.minconamounts, trigger: "blur" }] //券卡售价
      }, //基础设置表单验证
      // 基础设置表单
      verifytype:0,
      bcover:'',
      basicForm: {
				code:'',
				startvaldate:'',
				endvaldate:'',
        sketch: "", //打印备注
        ordercontent: "", //备注
				ordermemo:'',
        facevalue: "", //券卡面值
        minconamount: "", //券卡售价
        ticketDate: "", //有效期
				allamount:'',
      },
      //选择时间
      pickerOptions: {
       
      },
    };
  },
  props:{
    couponWriteOffShow:{
     default:false
    },
    membercode:{
      default:''
    },
    memberSource:{
      type:Number,
      default:0
    },//来源 1：会员上门
  },
  watch:{
    couponWriteOffShow: {
      handler: function(val) {
        if(val){
        this.basicForm={
            code:'',
            startvaldate:'',
            endvaldate:'',
            sketch: "", //打印备注
            ordercontent: "", //备注
            ordermemo:'',
            facevalue: "", //券卡面值
            minconamount: "", //券卡售价
            ticketDate: "", //有效期
            allamount:'',
          };
        this.basicForm.code=this.membercode
       this.yanzheng()
      }
      },
      deep: true,
      immediate: true
    },
  },
  // ============================================== 方法 ==============================================
  methods: {
    closeCoupon(val){
      if(val){
        this.suBmission()
      }else{
        this.$emit('closeCoupon',val)
      }
    },
    yanzheng(){
			if(this.basicForm.code==''){
				this.$message.error('优惠券编码不能为空！')
				 return
      }
      if(this.basicForm.code.length!=16&&this.basicForm.code.length!=20){
				this.$message.error('请输入16位或20位优惠券编码！')
				 return
			}
			this.loadingshows = true;
			Api.CHECKCOUPONVALID({code:this.basicForm.code}).then(res =>{
				if(res.data.status=="200"){
					this.loadingshows = false;
					let list = res.data.data;
					 this.basicForm.code = list.code;
					 this.basicForm.startvaldate = list.startvaldate;
					 this.basicForm.endvaldate = list.endvaldate;
					 this.basicForm.sketch = list.sketch;
					 this.basicForm.ordercontent = list.ordercontent;
					 this.basicForm.ordermemo = list.ordermemo;
					 this.basicForm.facevalue = list.facevalue;
					  this.basicForm.minconamount=list.minconamount;
				}else{
					this.loadingshows = false;
					this.$message.error(res.data.message)
				}
			})
		},
		 twoDateReceive(val) {
		   this.basicForm.ticketDate = val
		 },
    minconamount(val){
      if(val=='00'){
       this.basicForm.minconamount='';
      }else{
        this.basicForm.minconamount = this.amountChech(val);
      }
    },
    // 优惠券最低消费金额校验
    minconamounts(rule, value, callback){
      if(this.amountChech(value)&&value!=0){
         this.basicForm.minconamount = this.amountChech(value);
         callback();
      }else{
        callback(new Error("请输入有效金额！"));
      }
    },
    // 优惠券面值检验
    facevalues(rule, value, callback) {
      console.log(value)
      if(this.amountChech(value)&&value!=0){
         this.basicForm.facevalue = this.amountChech(value);
         callback();
      }else{
        callback(new Error("请输入有效金额！"));
      }
    },
    facevalue(val){
      if(val=='00'){
       this.basicForm.facevalue='';
      }else{
        this.basicForm.facevalue = this.amountChech(val);
      }
    },
		allamounts(val){
			if(val=='00'){
			 this.basicForm.allamount='';
			}else{
			  this.basicForm.allamount = this.amountChech(val);
			}
		},
    // 覆盖定义
    bcoVer(type){
      this.bcover = type
    },
    // 验证类型
    verifyType(type){
      this.verifytype = type
    },
    // 提交
    suBmission(){
            let param = {
                code:this.memberSource==1?this.membercode:this.basicForm.code,
								allamount:this.basicForm.allamount, 
								ordercontent:this.basicForm.ordercontent, 
								ordermemo:this.basicForm.ordermemo, 
            }
						if(this.basicForm.code==''){
							this.$message.error('优惠券编码不能为空')
							return
            }
            if(this.basicForm.code.length!=16&&this.basicForm.code.length!=20){
              this.$message.error('请输入16位或20位优惠券编码！')
              return
            }
						if(this.basicForm.allamount==''){
							this.$message.error('金额不能为空')
							return
						}
						if(this.basicForm.ordercontent==''){
							this.$message.error('订单内容不能为空')
							return
						}
						// if(this.basicForm.ordermemo==''){
						// 	this.$message.error('订单备注不能为空')
						// 	return
						// }
						this.loadingshow = true;
            Api.TOSUBMIT(param).then(res =>{
							this.loadingshow = false;
              if(res.data.status=="200"){
                this.$emit('closeCoupon',1)
								this.$message.success(res.data.message)
								this.basicForm={
									code:'',
									startvaldate:'',
									endvaldate:'',
								  sketch: "", //打印备注
								  ordercontent: "", //备注
									ordermemo:'',
								  facevalue: "", //券卡面值
								  minconamount: "", //券卡售价
								  ticketDate: "", //有效期
									allamount:'',
								};
							}else{
								this.$message.error(res.data.message)
							}
            })
    },
    reload(){
        this.basicForm.sketch='';
        this.basicForm.memo= ""; //备注
        this.basicForm.ticketDate= ""; //有效期
        // 移除组件
        this.update = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
            this.update = true
        })
    }
  },
  
};
</script>
<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
/* E 其他设置 */
.defineRow {position: relative;}
.defineRow .btnRight {position: absolute; left:calc(100% + 10px); display:inline-block; white-space: nowrap; cursor: pointer; color: #fff; -webkit-box-sizing: border-box; box-sizing: border-box;}
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/Coupon.vue